export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ05.a645d41a.mp3";